<template>
  <div>
    <div class="search">
      <div class="title">生产企业概况</div>
      <div class="form-contaner">
        <el-form label-width="110px" class="form">
          <el-row>
            <el-col :span="6">
              <el-form-item label="生产企业名称">
                <el-input
                  placeholder="请输入生产企业名称"
                  v-model="queryParams.compName"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属区域">
                <el-select v-model="queryParams.regionCode">
                  <el-option label="全部" value="" />
                  <el-option
                    v-for="item in cityList"
                    :key="item.id"
                    :label="item.short_name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产企业规模">
                <el-select v-model="queryParams.level">
                  <el-option label="全部" value="" />
                  <el-option label="注册资金>=1亿元" value="1" />
                  <el-option label="5千万<=注册资金<1亿元" value="2" />
                  <el-option label="1千万<=注册资金<5千万" value="3" />
                  <el-option label="5百万<=注册资金<1千万" value="4" />
                  <el-option label="1百万<=注册资金<5百万" value="5" />
                  <el-option label="注册资金<1百万" value="6" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="监管状态">
                <el-select v-model="queryParams.isRegister">
                  <el-option label="全部" value="" />
                  <el-option label="已监管" value="1" />
                  <el-option label="未监管" value="0" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="药品性质">
                <el-select v-model="queryParams.productType">
                  <el-option label="全部" value="" />
                  <el-option label="中药" value="中药" />
                  <el-option label="化学药品" value="化学药品" />
                  <el-option label="生物制品" value="生物制品" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="药品分类">
                <el-select v-model="queryParams.isSpecial">
                  <el-option label="全部" value="" />
                  <el-option label="特药" value="1" />
                  <el-option label="其它" value="0" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否OTC">
                <el-select v-model="queryParams.isPrescribed">
                  <el-option label="全部" value="" />
                  <el-option label="处方药" value="处方药" />
                  <el-option label="非处方药" value="非处方药" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button type="primary" @click="initQuery">查询</el-button>
        <el-button type="default" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="statistic">
      <div class="header"><span>数据统计</span></div>
      <div class="body">
        <div class="num-statics">
          <div class="title">
            <p class="text">生产企业数量统计</p>
            <p class="sub-text">生产企业数量与批准文号数量</p>
          </div>
          <div class="num-list">
            <div class="num-item">
              <div class="num">{{ entNum }}</div>
              <div class="text">生产企业总数量</div>
            </div>
            <div class="num-item">
              <div class="num">{{ licenseNoZcNum }}</div>
              <div class="text">在产批准文号总数量</div>
            </div>
            <div class="num-item">
              <div class="num">{{ licenseNoTcNum }}</div>
              <div class="text">停产批准文号总数量</div>
            </div>
          </div>
          <Echarts
            echartsHeight="475px"
            :echartsOption="echartsOption1"
            @tooltipClick="tooltipClick"
          />
        </div>
        <div class="scale-statics">
          <div class="title">
            <p class="text">生产企业规模统计</p>
            <p class="sub-text">按照注册资本统计</p>
          </div>
          <div class="num-list">
            <div class="num-item">
              <div class="num">{{ entNum }}</div>
              <div class="text">生产企业总数量</div>
            </div>
          </div>
          <Echarts
            :echartsOption="echartsOption2"
            echartsHeight="475px"
            @echartsClick="pieClick"
          />
        </div>
        <div class="border"></div>
      </div>
    </div>
    <div class="enterprise-list">
      <div class="header"><span>生产企业列表</span></div>
      <el-table :data="enterpriseList" :cell-style="renderCell">
        <el-table-column
          label="统一社会信用编码"
          prop="org_code"
          width="150px"
        />
        <el-table-column
          label="企业名称"
          prop="comp_name"
          width="160px"
          show-overflow-tooltip
        />
        <el-table-column label="注册状态" prop="is_register_text" />
        <el-table-column label="所属区域" prop="reg_region_name" />
        <el-table-column
          label="注册资金（万人民币）"
          prop="reg_capital"
          width="200px"
        />
        <el-table-column label="联系方式" prop="contact_tel" />
        <el-table-column label="企业地址" prop="reg_address" width="200px" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="font-size: 12px"
              @click="getDetail(scope.row)"
              >企业详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        layout="total, prev, pager, next, jumper"
        :total="total"
        :current-page="currentPage"
        @current-change="loadEnterpriseList"
        :page-size="5"
      />
    </div>
    <enterprise-detail
      :detailVisible="detailVisible"
      :closeDialog="closeDialog"
      :enterpriseId="enterpriseId"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Echarts from 'components/echarts/echarts';
import EnterpriseDetail from 'components/enterprise-detail/enterprise-detail';
var colors = ['#5793f3', '#d14a61', '#675bba'];

export default {
  data() {
    return {
      queryParams: {
        compName: '',
        regionCode: '',
        level: '',
        isRegister: '',
        productType: '',
        isSpecial: '',
        isPrescribed: ''
      },
      entNum: 0,
      licenseNoTcNum: 0,
      licenseNoZcNum: 0,
      allAreaInfoList: [],
      echartsOption1: {
        color: colors,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          top: '5%',
          right: '20%',
          left: '0',
          containLabel: true
        },
        xAxis: [
          {
            type: 'value',
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(206,219,239, 0.5)'
              }
            },
            axisLabel: {
              color: '#000'
            },
            max: ''
          },
          {
            type: 'value',
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(206,219,239, 0.5)'
              }
            },
            axisLabel: {
              color: '#000'
            },
            minInterval: 1
          }
        ],
        yAxis: [
          {
            type: 'category',
            position: 'left',
            axisLine: {
              lineStyle: {
                color: 'rgba(206,219,239, 0.5)'
              }
            },
            axisLabel: {
              color: '#000'
            },
            axisTick: {
              show: false
            },
            data: [],
            triggerEvent: true
          }
        ],
        series: [
          {
            type: 'bar',
            name: '在产批准文号总数量',
            barWidth: '8px',
            data: [],
            barGap: 0,
            itemStyle: {
              color: '#4C4ACC'
            },
            xAxisIndex: 0
          },
          {
            type: 'bar',
            name: '停产批准文号总数量',
            barWidth: '8px',
            data: [],
            itemStyle: {
              color: '#FFCF39'
            },
            xAxisIndex: 0
          },
          {
            type: 'line',
            name: '生产企业总数量',
            barWidth: '8px',
            data: [],
            itemStyle: {
              color: '#26D0A4'
            },
            xAxisIndex: 1,
            symbol: 'circle',
            symbolSize: 8
          }
        ]
      },
      echartsOption2: {
        gird: {
          containLabel: true
        },
        legend: [
          {
            bottom: '60px',
            x: 'center',
            itemGap: 21,
            data: [
              '注册资金≥1亿',
              '5千万≤注册资金＜1亿',
              '1千万≤注册资金＜5千万'
            ],
            itemWidth: 12,
            itemHeight: 12,
            icon: 'circle'
          },
          {
            bottom: '30px',
            x: 'center',
            itemGap: 21,
            data: [
              '5百万≤注册资金＜1千万',
              '1百万≤注册资金＜5百万',
              '注册资金＜1百万'
            ],
            itemWidth: 12,
            itemHeight: 12,
            icon: 'circle'
          }
        ],
        backgroundColor: '#ffffff',
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        color: [
          '#0B428A',
          '#975FE4',
          '#386CE2',
          '#FFB439',
          '#2BBF99',
          '#CEDBEF'
        ],
        series: [
          {
            name: '生产企业规模',
            type: 'pie',
            center: ['50%', '40%'],
            radius: ['40%', '55%'],
            data: [],
            label: {
              show: false
            },
            itemStyle: {
              normal: {
                borderColor: '#ffffff',
                borderWidth: 5
              }
            }
          },
          {
            name: '生产企业规模',
            type: 'pie',
            animation: false,
            center: ['50%', '40%'],
            radius: ['60%', '65%'],
            data: [],
            label: {
              normal: {
                color: '#386CE2',
                formatter: '{c|数量：{c}}\n{d|{d}%}',
                rich: {
                  c: {
                    color: '#386CE2'
                  },
                  d: {
                    color: '#999999',
                    lineHeight: '20'
                  }
                }
              }
            },
            labelLine: {
              show: true,
              lineStyle: {
                color: '#386CE2'
              }
            },
            itemStyle: {
              normal: {
                borderColor: '#ffffff',
                borderWidth: 5
              }
            }
          },
          {
            name: '生产企业规模',
            type: 'pie',
            center: ['50%', '40%'],
            radius: ['0', '30%'],
            data: [{ value: 100 }],
            itemStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(206, 219, 239, 1)' // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(206, 219, 239, 0)' // 100% 处的颜色
                    }
                  ],
                  globalCoord: false // 缺省为 false
                }
              }
            },
            tooltip: {
              show: false
            },
            label: {
              normal: {
                formatter: '生产企业规模',
                position: 'center',
                textStyle: {
                  fontSize: 16,
                  color: '#386CE2'
                }
              }
            }
          }
        ]
      },
      enterpriseList: [],
      total: 0,
      currentPage: 1,
      enterpriseId: '',
      detailVisible: false
    };
  },
  computed: {
    ...mapState(['cityList'])
  },
  mounted() {
    this.initQuery();
  },
  methods: {
    initQuery() {
      this.loadEnterpriseCount();
      this.loadEnterpriseScale();
      this.loadEnterpriseList(1);
    },
    // 企业数量
    loadEnterpriseCount() {
      this.$request({
        url: 'rest/production/productionEntStatics',
        data: {
          json: JSON.stringify({
            params: {
              ...this.queryParams
            }
          })
        }
      }).then(res => {
        this.entNum = res.entNum;
        this.licenseNoTcNum = res.licenseNoTcNum;
        this.licenseNoZcNum = res.licenseNoZcNum;
        this.allAreaInfoList = res.allList;
        const yData = [];
        const zcData = [];
        const tcData = [];
        const entData = [];
        const maxData = [];
        res.allList.reverse().forEach(item => {
          yData.push(item.short_name);
          entData.push(item.num);
          tcData.push(item.licenseNoTcNum);
          zcData.push(item.licenseNoZcNum);
        });
        const max = Math.max.apply(null, zcData.concat(tcData));
        this.echartsOption1.xAxis[0].max = max;
        yData.forEach(item => {
          maxData.push(max);
        });
        this.echartsOption1.yAxis[0].data = yData;

        this.echartsOption1.series[0].data = zcData;
        this.echartsOption1.series[1].data = tcData;
        this.echartsOption1.series[2].data = entData;
        // this.echartsOption1.series[3].data = maxData;
      });
    },
    // 企业数量echarts单击进入地区企业数量
    tooltipClick(xIndex, yIndex) {
      // const code = this.allAreaInfoList[yIndex].city_code;
      // const name = this.allAreaInfoList[yIndex].short_name;
      const current = this.allAreaInfoList[yIndex];
      if (
        this.queryParams.regionCode &&
        current.city_code !== this.queryParams.regionCode
      ) {
        return;
      }
      this.$router.push({
        path: `/page/productingEnterprise/drugInfo/${current.city_code}`
      });
    },
    // 企业规模
    loadEnterpriseScale() {
      this.$request({
        url: 'rest/production/productionScaleStatics',
        data: {
          json: JSON.stringify({
            params: {
              ...this.queryParams,
              regRegionCode: '650000'
            }
          })
        }
      }).then(res => {
        const data = [
          {
            name: '注册资金≥1亿',
            value: res.num1
          },
          {
            name: '5千万≤注册资金＜1亿',
            value: res.num2
          },
          {
            name: '1千万≤注册资金＜5千万',
            value: res.num3
          },
          {
            name: '5百万≤注册资金＜1千万',
            value: res.num4
          },
          {
            name: '1百万≤注册资金＜5百万',
            value: res.num5
          },
          {
            name: '注册资金＜1百万',
            value: res.num6
          }
        ].filter(item => item.value);
        if (data.length === 1) {
          this.echartsOption2.series[0].itemStyle.normal.borderWidth = 0;
          this.echartsOption2.series[1].itemStyle.normal.borderWidth = 0;
        }
        this.echartsOption2.series[0].data = data;
        this.echartsOption2.series[1].data = data;
      });
    },
    // 企业规模echarts单击进入规模详情
    pieClick(params) {
      if (!params.name) {
        return;
      }
      const map = {
        '注册资金＜1百万': '6',
        '1百万≤注册资金＜5百万': '5',
        '5百万≤注册资金＜1千万': '4',
        '1千万≤注册资金＜5千万': '3',
        '5千万≤注册资金＜1亿': '2',
        '注册资金≥1亿': '1'
      };
      const level = map[params.name];
      this.$router.push({
        path: `/page/productingEnterprise/scale/${level}`
      });
    },
    loadEnterpriseList(currentPage) {
      this.currentPage = currentPage;
      this.$request({
        url: 'open/statistic/reportData',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: this.currentPage,
              pageSize: 5
            },
            params: {
              ...this.queryParams,
              handlerName: 'production_qygk_list'
            }
          })
        }
      }).then(res => {
        this.total = res ? res.total : 0;
        this.enterpriseList = res.list.map(item => ({
          ...item,
          is_register_text: item.is_register === 0 ? '未注册' : '已注册'
        }));
      });
    },
    reset() {
      for (const key in this.queryParams) {
        this.queryParams[key] = '';
      }
    },
    getDetail(row) {
      this.enterpriseId = row.id;
      this.detailVisible = true;
    },
    closeDialog() {
      this.detailVisible = false;
    },
    renderCell({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2) {
        if (row.is_register === 0) {
          return { color: '#FFB439' };
        } else {
          return { color: '#2BBF99' };
        }
      }
    }
  },
  components: {
    Echarts,
    EnterpriseDetail
  }
};
</script>

<style lang="stylus" scoped>
.el-table
  font-size 12px
.search
  .title
    background url('~assets/images/bg-circle.png')
    background-size cover
    height 74px
    line-height 60px
    padding-left 21px
    font-size 18px
    border-radius 8px 8px 0 0
  .form-contaner
    position relative
    background #fff
    border-radius 8px
    transform translate(0, -16px)
    padding 20px
    text-align center
    .form
      margin-bottom 30px
.statistic, .enterprise-list
  padding 0 20px
  background #fff
  margin-top 20px
  border-radius 8px
  overflow hidden
  color #000
  .body
    position relative
    overflow hidden
    .num-statics
      position relative
      width 50%
      float left
      .echarts-border
        position absolute
        width 1px
        background rgba(206,219,239,.5)
        left 504px
        top 190px
        height 320px
    .scale-statics
      width 50%
      float left
      .title
        padding-left 30px
    .border
      width 1px
      position absolute
      top 0
      left 50%
      bottom 50px
      background rgba(206,219,239,.5)
    .title
      border-bottom 1px solid #CEDBEF
      padding 5px 0
      .text
        font-size 14px
        margin-bottom 5px
      .sub-text
        font-size 12px
        color #666666
    .num-list
      display flex
      justify-content center
      .num-item
        margin 0 20px
        text-align center
        padding-top 30px
        .num
          color #386CE2
          font-size 28px
        .text
          font-size 12px
  .header
    color #000000
    border-bottom 1px solid #CEDBEF
    padding 20px 0
    span
      border-left 4px solid #386CE2
      padding-left 10px
.pagination
  padding 20px
  float right
</style>
